import { render, staticRenderFns } from "./ClassroomDetailGroupEdit.vue?vue&type=template&id=1f0d7082&scoped=true"
import script from "./ClassroomDetailGroupEdit.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailGroupEdit.vue?vue&type=style&index=0&id=1f0d7082&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d7082",
  null
  
)

export default component.exports